import {
  AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, Input, OnChanges, OnInit,
  PLATFORM_ID,
  SimpleChanges,
  Inject,
} from '@angular/core';
import {Work} from '../../models/work';
import {WorksService} from '../../services/works.service';
import {ActivatedRoute, ParamMap, Params} from '@angular/router';
import {isPlatformServer, Location} from '@angular/common';

import 'rxjs/add/operator/switchMap';
import {ScrollPositionService} from '../../services/scroll-position.service';

@Component({
  selector: 'app-work-detail',
  templateUrl: './work-detail.component.html',
  styleUrls: ['./work-detail.component.css'],
})
export class WorkDetailComponent implements OnInit, AfterViewInit {
  loading: Boolean = true;
  @Input() slug: string;
  @Input() work: Work;
  works: Work[] = [];
  nextWork: Work;
  previousWork: Work;
  inComponent = false;
  checked = false;

  constructor(private spService: ScrollPositionService,
              private worksService: WorksService,
              private route: ActivatedRoute,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    console.log('OnInit');
    if (isPlatformServer(this.platformId)) {
      this.worksService.retrieveWorks();
    }
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.slug = params.get('slug');
      return this.worksService.works;
    }).subscribe((works) => {
      console.log('In subscribe');
      this.works = works;
      this.setWork(works.filter((work) => {
        return work.slug === this.slug;
      })[0]);
      this.previousWork = this.getNewerWork();
      this.nextWork = this.getPreviousWork();
      if (this.inComponent) {
        this.spService.autoScroll();
      }
    });
  }

  setWork(work: Work): void {
    this.work = work;
  }

  getNewerWork(): Work {
    const newerWorks = this.works.filter((work) => {
      return work.dateCompleted.getTime() > this.work.dateCompleted.getTime();
    });
    console.log(newerWorks);
    return newerWorks[newerWorks.length - 1];
  }

  getPreviousWork(): Work {
    const previousWorks = this.works.filter((work) => {
      return work.dateCompleted.getTime() < this.work.dateCompleted.getTime();
    });
    console.log(previousWorks);
    return previousWorks[0];
  }

  scrollToTop(): void {
    this.spService.scrollToTop();
  }

  ngAfterViewInit() {
    console.log('AfterViewInit');
    this.spService.autoScroll();
    this.inComponent = true;
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/work-detail/work-detail.component.ts